import { Close as BaseClose, InsertDriveFileOutlined as BaseFileIcon } from '@mui/icons-material'
import { Divider as DividerBase, styled } from '@mui/material'

import { BaseContainer, BaseItem } from '../../config/styles/BaseGrid'

export const AttachedFiles = styled(BaseContainer)``

export const Container = styled(BaseContainer)``

export const Divider = styled(({ margin, ...props }) => <DividerBase {...props} />)`
  &.MuiDivider-root {
    margin: ${props => props.margin};
  }
`

export const FileCard = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.white};
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 8px;
  display: flex;
  gap: 12px;
  padding: 16px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  width: 100%;

  &:hover {
    border-color: ${props => props.theme.palette.brand.primary};
    box-shadow: 0 2px 8px rgba(0, 100, 255, 0.08);
  }
`

export const FileIcon = styled(BaseFileIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.primary};
    height: 24px;
    width: 24px;
  }
`

export const FileInfo = styled(BaseContainer)`
  flex-direction: column;
  flex: 1;

  .file__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const Files = styled(BaseItem)``

export const FileUploadInfo = styled(BaseContainer)``

export const FileUploadWrapper = styled(BaseContainer)`
  gap: 32px;

  ${props => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 16px;
  }
`

export const HiddenInput = styled('input')`
  display: none;
`

export const Item = styled(BaseItem)``

export const RemoveIcon = styled(({ disabled, ...props }) => <BaseClose {...props} />)`
  &.MuiSvgIcon-root {
    background-color: transparent;
    border-radius: 50%;
    color: ${props =>
      props.disabled ? props.theme.palette.brand.disableFont : props.theme.palette.brand.black3};
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    flex-shrink: 0;
    height: 20px;
    padding: 4px;
    pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
    width: 20px;

    &:hover {
      background-color: ${props => !props.disabled && 'rgba(239, 68, 68, 0.1)'};
      color: ${props => !props.disabled && props.theme.palette.brand.error};
    }
  }
`

export const Root = styled(BaseContainer)``
